import axios from 'axios';

const Api = {
  api(contentType = 'application/json') {
    let headers = {
      'Accept': 'application/json',
      'device-id': localStorage.deviceId,
    };
    headers['Content-Type'] = contentType;
    if (localStorage.jwtToken) {
      headers['Authorization'] = 'Bearer ' + localStorage.jwtToken;
    }
    return axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers,
      jar: true,
    });
  },

  sendLoginEmail(useremail) {
    return this.api().post('/login/' + useremail);
  },

  login(emailtoken) {
    return this.api().post('/login/token/' + emailtoken);
  },

  getProfile() {
    return this.api().get('/profile');
  },

  getChats() {
    return this.api().get('/chat');
  },

  getAllChats() {
    return this.api().get('/chat/allchats');
  },

  getMessages(chatId) {
    return this.api().get(`/chat/${chatId}/messages`);
  },

  assignChat(chatId) {
    return this.api().post(`/chat/assign/${chatId}`);
  },

  queueChat(chatId) {
    return this.api().post(`/chat/unassign/${chatId}`);
  },

  closeChat(chatId) {
    return this.api().delete(`/chat/${chatId}`);
  },

  closeClinicAppointmentChat(chatId, clinicId, appointmentTime, details) {
    return this.api().delete(`/chat/${chatId}`, {
      data: {
        appointmentDetails: {
          clinicId,
          appointmentTime,
          details,
        },
      },
    });
  },

  startVideo(chatId) {
    return this.api().post(`/chat/${chatId}/video`);
  },

  stopVideo(chatId) {
    return this.api().delete(`/chat/${chatId}/video`);
  },

  sendFeedback(chatId, selection, details) {
    return this.api().post(`/chat/${chatId}/feedback`, {selection, details});
  },

  saveProfile(profile) {
    return this.api().post('/profile', profile);
  },

  saveSomeonesProfile(profile, userId) {
    return this.api().post(`/profile/update/${userId}`, profile);
  },

  createNewProfile(profile, email) {
    return this.api().post(`/profile/create/${email}`, profile);
  },

  findProfile(userId) {
    return this.api().get(`/profile/${userId}`);
  },

  activateProfile(userId) {
    return this.api().post(`/profile/activate/${userId}`);
  },

  giveSuperUserRights(userId) {
    return this.api().post(`/profile/upgradeToSuperUser/${userId}`);
  },

  removeSuperUserRights(userId) {
    return this.api().post(`/profile/downgradeToNormalUser/${userId}`);
  },

  deactivateProfile(userId) {
    return this.api().post(`/profile/deactivate/${userId}`);
  },

  getListOfProfiles() {
    return this.api().get('/profile/all');
  },

  saveProfileImage(image) {
    return this.api('multipart/form-data').post(`/profile/image?type=${image.type}`, image);
  },

  saveSomeonesProfileImage(image, userId) {
    return this.api('multipart/form-data').post(`/profile/updateImage/${userId}/image?type=${image.type}`, image);
  },

  savePhrase(userId, phrase) {
    return this.api().post(`/profile/savePhrase/${userId}`, phrase);
  },

  deletePhrase(userId, hashtag) {
    return this.api().delete(`/profile/deletePhrase/${userId}/h-${encodeURIComponent(hashtag)}`);
  },

  saveCompanyPhrase(phrase) {
    return this.api().post(`/profile/saveCompanyPhrase/${encodeURIComponent(phrase.hashtag)}`, {
      phrase: phrase.phrase,
    });
  },

  deleteCompanyPhrase(hashtag) {
    return this.api().delete(`/profile/deleteCompanyPhrase/${encodeURIComponent(hashtag)}`);
  },

  getClinics() {
    return this.api().get('/locations/clinics');
  },

  getCompanies() {
    return this.api().get('/locations/companies');
  },
}

export default Api;
